/** @jsx jsx */
// eslint-disable-next-line
import React, { Component, Fragment, useState, useEffect } from 'react'
import { css, jsx } from '@emotion/core'
import PropTypes from 'prop-types'
import logo from '../../assets/logo.png'
import logoMobile from '../../assets/logo-mobile.png'
import { headerHeight } from '../../constants'

const styles = {}
styles.container = css`
  height: ${headerHeight}px;
  width: 100%;
  padding: 0 20px;
  position: absolute;
  z-index: 99;
  display: flex;
  align-items: center;

  @media (max-width: 700px) {
    justify-content: flex-start;
  }
`

styles.clickButton = css`
  border: 0;
  background: transparent;
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  cursor: pointer;
  margin-left: 40px; 

  @media (max-width: 700px) {
    margin-left: 0;
  }
`

function Header(props) {
  const [logoSrc, setLogoSrc] = useState(window.screen.width >= 700 ? logo : logoMobile)
  const [windowWidth, setWindowWidth] = useState(window.screen.width)

  const resizeWindow = () => {
    const logoResize = window.innerWidth >= 700 ? logo : logoMobile

    setLogoSrc(logoResize)
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    resizeWindow()
    window.addEventListener('resize', resizeWindow)
    return () => window.removeEventListener('resize', resizeWindow)
  }, [])

  return (
    <header css={styles.container}>
      <a
        href="http://metrica-sports.com"
        css={styles.clickButton}
        style={{ width: `${windowWidth >= 700 ? 250 : 39}px` }}
      >
        <img src={logoSrc} alt="Metrica Sports" style={{ width: '100%' }} />
      </a>
    </header>
  )
}

Header.propTypes = {
  referral: PropTypes.string
}

Header.defaultProps = {
  referral: undefined
}

export default Header
